import en from "@/langs/en.json";
import hy from "@/langs/hy.json";
import ru from "@/langs/ru.json";

export const locales = ['en', 'ru', 'hy'];

export const defaultLocale = 'en';

export const localePrefix = 'always';

export const translations = {en, hy, ru};
